import React from 'react'
import { VersionUnavailableFragment } from 'gqlTypes'
import VersionItem from 'components/VersionItem/VersionItem'

export interface ShareVersionItemProps {
  version: VersionUnavailableFragment
}

export const ShareVersionUnavailable = ({ version }: ShareVersionItemProps) => {
  const { userIsCreator, creator } = version
  const createdAt = new Date(version.createdAt)

  return (
    <VersionItem
      type="unavailable"
      creator={creator.name!}
      date={createdAt}
      userIsCreator={userIsCreator}
      tooltip="Updates created before July 23, 2019 are not available"
      kind={'DRAFT'}
    />
  )
}
